<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      
      <h2 class="dark-grey--text px-2 pt-3"><v-chip color="green" class="white--text" v-if="applicationInfo.isResolved&&applicationInfo.isApproved">Approved</v-chip>
        <v-chip color="red" class="white--text" v-else-if="applicationInfo.isResolved&&applicationInfo.isDenied">Denied</v-chip>
        <v-chip color="light-blue" class="white--text" v-else>Pending</v-chip>Application: {{applicationInfo.name}}</h2>
   
  
</v-toolbar>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}      
           <v-icon color="green"
            v-if="tab.name==='orgInfo' && applicationInfo.isValidated==true" >check_circle</v-icon>
           <v-icon color="red"
            v-else-if="tab.name==='orgInfo' && applicationInfo.isValidated==false">cancel</v-icon>
          <v-icon  color="green"
          v-if="tab.name==='contactInfo' && applicationInfo.isContactVerified==true">check_circle</v-icon>
          <v-icon color="red"
          v-else-if="tab.name==='contactInfo' && applicationInfo.isContactVerified==false">cancel</v-icon>
          <v-icon  color="green"
          v-if="tab.name==='linksTab' && applicationInfo.isDocumentsVerified==true&&applicationInfo.isLinksVerified==true">check_circle</v-icon>
         <v-icon color="red"
          v-else-if="tab.name==='linksTab' && (applicationInfo.isDocumentsVerified===false||applicationInfo.isLinksVerified===false)">cancel</v-icon> 
 </v-tab>
 
 </v-tabs>
        <v-spacer></v-spacer>    
        <v-btn @click="approve();" round v-if="!applicationInfo.isResolved&&!loading
        &&(applicationInfo.isDocumentsVerified
        &&applicationInfo.isLinksVerified
        &&applicationInfo.isValidated
        &&applicationInfo.isContactVerified)" class="white--text primary">Approve</v-btn>
        <v-btn v-if="!applicationInfo.isResolved" round color="red" class="white--text" @click="deniedReasonModal=true">Reject</v-btn>
    </v-toolbar>
   
    <v-divider></v-divider>

     <div v-if="displayContents('orgInfo')"> 
    <v-container style="text-align:center" >
      <v-layout wrap>
        <v-flex >         
             <h2 class="dark-grey--text font-weight-bold"><v-icon v-if="!applicationInfo.isValidated" color="orange">warning</v-icon>
             <v-btn v-if="applicationInfo.name==''||applicationInfo.name==null
                ||applicationInfo.registeredName==''||applicationInfo.registeredName==null      
                ||applicationInfo.physicalAddressLine1==''||applicationInfo.physicalAddressLine1==null
                ||applicationInfo.physicalAddressLine2==''||applicationInfo.physicalAddressLine2==null
                ||applicationInfo.physicalAddressLine3==''||applicationInfo.physicalAddressLine3==null
                ||applicationInfo.physicalAddressLine4==''||applicationInfo.physicalAddressLine4==null
                ||applicationInfo.physicalAddressLine5==''||applicationInfo.physicalAddressLine5==null
                ||applicationInfo.organisationTypeId==null" disabled round color="primary">Validate</v-btn>
                <v-btn v-if="!applicationInfo.isValidated &&
                applicationInfo.name!==''&&applicationInfo.name!==null
                &&applicationInfo.registeredName!==''&&applicationInfo.registeredName!==null   
                &&applicationInfo.physicalAddressLine1!==''&&applicationInfo.physicalAddressLine1!==null
                &&applicationInfo.physicalAddressLine2!==''&&applicationInfo.physicalAddressLine2!==null
                &&applicationInfo.physicalAddressLine3!==''&&applicationInfo.physicalAddressLine3!==null
                &&applicationInfo.physicalAddressLine4!==''&&applicationInfo.physicalAddressLine4!==null
                &&applicationInfo.physicalAddressLine5!==''&&applicationInfo.physicalAddressLine5!==null
                &&applicationInfo.organisationTypeId!==null" 
                @click="validateFields()" round color="primary">Validate</v-btn>
                <v-btn v-if="applicationInfo.isValidated"  round color="primary" disabled><v-icon color="white">check</v-icon> Validated</v-btn></h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12  text-xs-left>
                    <v-layout justify-left>
                        <v-flex xs6>
                            <h2  class="subheading grey--text font-weight-bold"> *Organisation Registered Name: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field class="mt-0 pt-0 mx-2" :rules="regNameRules" v-model="applicationInfo.registeredName"></v-text-field>
                        </v-flex>
                         <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Unit No. & Building Name: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.physicalAddressLine1"></v-text-field>
                        </v-flex>
                    </v-layout>
                      <v-layout justify-left>
                        <v-flex xs6>
                            <h2 class="input-flex-min-space subheading grey--text font-weight-bold"> *Organisation Trading-As Name: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field :rules="nameRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.name"></v-text-field>
                        </v-flex>
                         <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> *Street No. & Name: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field :rules="line2Rules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.physicalAddressLine2"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                      <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Preferred VLAN:</h2>
                      </v-flex>
                 <v-flex xs6>
                       <v-autocomplete class="mt-0 pt-0 mx-2" clearable :items="vlans" v-model="applicationInfo.preferredVlan"></v-autocomplete>
                 </v-flex>
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> *City: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field :rules="line3Rules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.physicalAddressLine3"></v-text-field>
                        </v-flex>
                    </v-layout>
                   
                    <v-layout justify-center >
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> VAT Number: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.vatNo"></v-text-field>
                        </v-flex>
                          <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> *Zip Code: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field :rules="line4Rules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.physicalAddressLine4"></v-text-field>
                        </v-flex>
                    </v-layout>                    
                    <v-layout justify-center >
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Primary Colour: </h2>
                        </v-flex>
                        <v-flex xs6>
                    <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.primaryColour"></v-text-field>
                        </v-flex>
                             <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> *Province: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field :rules="line5Rules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.physicalAddressLine5"></v-text-field>
                        </v-flex>
                      
                    </v-layout>
                    <v-layout justify-center >
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold">Secondary Colour: </h2>
                        </v-flex>
                        <v-flex xs6>
                        <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.secondaryColour"></v-text-field>
                        </v-flex>
                           <v-flex xs6>
                        <v-select class="mt-0 pt-0 mx-2" 
                          :items="organisationTypes"
                          item-text="name"
                          item-value="id"
                          :rules="orgTypeRules"
                          label="*Organisation Type"
                          v-model="applicationInfo.organisationTypeId"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6></v-flex>
                    </v-layout>
                  
                </v-flex>
              </v-layout>
            </v-container>
          
        </v-flex>
      </v-layout>
    </v-container>
   
     </div>


<div v-if="displayContents('contactInfo')">

<v-container style="text-align:center" >
      <v-layout wrap>
        <v-flex >         
            <h2 class="dark-grey--text font-weight-bold"><v-icon v-if="!applicationInfo.isContactVerified" color="orange">warning</v-icon>
                <v-btn v-if="applicationInfo.primaryContactId==null 
                ||applicationInfo.customerSupportEmail===''||applicationInfo.customerSupportEmail==null|| !this.validEmail(this.applicationInfo.customerSupportEmail)
                ||applicationInfo.customerSupportTelephone === ''|| applicationInfo.customerSupportTelephone == null || applicationInfo.customerSupportTelephone.length < 10
                ||applicationInfo.customerSupportTelephoneDescription === ''|| applicationInfo.customerSupportTelephoneDescription == null
                ||applicationInfo.customerSupportEmailDescription === ''|| applicationInfo.customerSupportEmailDescription == null"
                disabled round color="primary">Verify</v-btn>

                <v-btn v-if="!applicationInfo.isContactVerified
                 &&applicationInfo.primaryContactId!==null 
                 &&applicationInfo.customerSupportEmail!==''&&applicationInfo.customerSupportEmail!==null&& this.validEmail(this.applicationInfo.customerSupportEmail)
                 &&applicationInfo.customerSupportTelephone !== ''&& applicationInfo.customerSupportTelephone !== null && applicationInfo.customerSupportTelephone.length >= 10
                 &&applicationInfo.customerSupportTelephoneDescription !== '' && applicationInfo.customerSupportTelephoneDescription !== null
                 &&applicationInfo.customerSupportEmailDescription !== '' && applicationInfo.customerSupportEmailDescription !== null
               
                " @click="verifyContact" round color="primary">Verify</v-btn>
               
                <v-btn v-if="applicationInfo.isContactVerified" round color="primary" disabled><v-icon color="white">check</v-icon> Verified</v-btn>
                
                </h2>                  
            <v-container >
              <v-layout wrap>
                <v-flex xs12 sm12 md12  text-xs-left>
                    <v-layout justify-left>                        
                      <v-flex xs8>
                          
                             <v-layout>
                             <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold">*Customer Support Email Address:</h2>
                            </v-flex>
                              <v-flex xs6>
                            <v-text-field  :rules="customerEmailRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportEmail"></v-text-field>
                          </v-flex>
                          </v-layout>
                           <v-layout>
                            <v-flex xs6>
                              <h2 class="subheading grey--text font-weight-bold">*Customer Support Contact Number:</h2>
                            </v-flex>
                              <v-flex xs6>
                              <v-text-field  :rules="customerContactRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportTelephone"></v-text-field>
                          </v-flex>
                          </v-layout>
                           <v-layout>
                             <v-flex xs6>
                       <h2 class="subheading grey--text font-weight-bold">Customer Support Whatsapp number:</h2>
                       </v-flex>
                        <v-flex xs6>
                       <v-text-field  class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportWhatsapp"></v-text-field>
                      </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6>
                       <h2 class="subheading grey--text font-weight-bold">*Customer Support Email Availability:</h2>
                      </v-flex>
                        <v-flex xs6>
                       <v-textarea :rules="customerEmailDescriptionRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportEmailDescription"></v-textarea>
                        </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6>
                       <h2 class="subheading grey--text font-weight-bold">*Customer Support Telephone Availability:</h2>
                      </v-flex>
                        <v-flex xs6>
                       <v-textarea :rules="customerTelephoneDescriptionRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportTelephoneDescription"></v-textarea>
                        </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6>
                       <h2 class="subheading grey--text font-weight-bold">Customer Support Whatsapp Availability:</h2>
                      </v-flex>
                        <v-flex xs6>
                       <v-textarea class="mt-0 pt-0 mx-2" v-model="applicationInfo.customerSupportWhatsappDescription"></v-textarea>
                        </v-flex>
                          </v-layout>
                      </v-flex>
                      <v-flex xs4>
                           <v-container v-if="showApplicationContacts">
                  <v-layout justify-center >
                    <v-flex >
                      <v-card hover class="text-xs-center mx-2">
                        <div
                          class="primary subheading text-uppercase white--text"
                        >Primary</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <div class="subheading" v-if="applicationInfo.primaryContactTitle!==null">{{applicationInfo.primaryContactTitle}} {{applicationInfo.primaryContactFirstname}} {{applicationInfo.primaryContactLastname}}</div>
                          <div class="subheading" v-else>{{applicationInfo.primaryContactFirstname}} {{applicationInfo.primaryContactLastname}}</div>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">smartphone</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{applicationInfo.primaryContactMobileNumber}}</div>
                          </v-flex>
                          </v-layout>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">email</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{applicationInfo.primaryContactEmailAddress}}</div>
                          </v-flex>
                          </v-layout>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">perm_identity</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{applicationInfo.primaryContactIdNumber}}</div>
                          </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                          <v-layout justify-center wrap>
                             <v-btn class="ma-1" v-if="applicationInfo.primaryContactId===null" round color="primary" @click="editContact('Primary')">
                            <v-icon small>edit</v-icon> Edit
                          </v-btn>
                          <v-btn class="ma-1" v-if="applicationInfo.primaryContactId===null&&!linkedPrimaryContacts.length>0" round color="primary" @click="addContact('Primary')">
                            <v-icon small>person_add</v-icon> Create Contact
                          </v-btn>
                          <v-btn class="ma-1 white--text" v-if="applicationInfo.primaryContactId===null&&linkedPrimaryContacts.length>0" round color="orange" @click="similarContactsModalPrimary=true">
                            <v-icon small color="white">error_outline</v-icon> Similar Accounts
                          </v-btn>
                          <v-btn class="ma-1" round disabled v-else-if="applicationInfo.primaryContactId!==null">
                            <v-icon small>check</v-icon>Added
                          </v-btn>
                          </v-layout>
                        
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                    
                  </v-layout>
                </v-container>
                    </v-flex>
                    </v-layout>
                 </v-flex>
              </v-layout>
            </v-container>
          
        </v-flex>
      </v-layout>
    </v-container>
</div>
      
      <div v-if="displayContents('linksTab')"> 
     <v-card flat>
    <v-container grid-list-xs>
      <v-layout wrap>
        <v-flex xs6 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold"><v-icon v-if="!applicationInfo.isLinksVerified" color="orange">warning</v-icon> Links 
  
            <v-btn v-if="
            applicationInfo.websiteUrl!== '' &&applicationInfo.websiteUrl !== null
            &&applicationInfo.termsAndConditionsLink !== '' &&applicationInfo.termsAndConditionsLink !== null
            &&validateLink()&&(!applicationInfo.isLinksVerified)" round class="white--text primary" @click="verifyLinks()">Verify</v-btn>
           
            <v-btn v-if="applicationInfo.isLinksVerified" round disabled><v-icon color="white">check</v-icon>Verified</v-btn>
            </h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                   <v-flex xs12 sm12 md12  text-xs-left>
                    <v-layout justify-center>
                        <v-flex xs4>
                            <h2 class="subheading grey--text font-weight-bold">*Website URL: </h2>
                        </v-flex>
                        <v-flex xs8>
                        <v-text-field :rules="webUrlRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.websiteUrl"></v-text-field>
                         </v-flex>
                        
                    </v-layout>
                    <v-layout justify-center>
                       <v-flex xs4>
                            <h2 class="subheading grey--text font-weight-bold">FUP URL: </h2>
                        </v-flex>
                        <v-flex xs8>
                       <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.fupUrl"></v-text-field>
                         </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                       <v-flex xs4>
                            <h2 class="subheading grey--text font-weight-bold">*T's & C's Link: </h2>
                        </v-flex>
                        <v-flex xs8>
                      <v-text-field :rules="tcLinkRules" class="mt-0 pt-0 mx-2" v-model="applicationInfo.termsAndConditionsLink"></v-text-field>
                         </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
              
            </v-container>
          </v-card-text>
        </v-flex>
         <v-flex xs6 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold"><v-icon v-if="!applicationInfo.isDocumentsVerified" color="orange">warning</v-icon> Documents 
            <v-btn v-if="(!applicationInfo.isDocumentsVerified)" round class="white--text primary" @click="verifyDocument()">Verify</v-btn>
            <v-btn v-if="applicationInfo.isDocumentsVerified" round disabled><v-icon color="white">check</v-icon>Verified</v-btn>
            </h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                   <v-flex xs12 sm12 md12  text-xs-left>
                    <v-layout justify-center>
                      <v-flex xs2>
                        <v-layout>                         
                         <v-flex xs6>
                        <v-icon @click="$refs.fileLogoInput.click()" medium color="primary">cloud_upload</v-icon>
                       <input style="display: none" class="file-input" @change="selectFile($event, 'logo')"  ref="fileLogoInput" type="file">
                         </v-flex>
                        </v-layout>
                        </v-flex>
                        <v-flex xs10>
                            <h2 class="subheading grey--text font-weight-bold">Logo Complete: </h2>
                        </v-flex>
                        <v-flex xs2>
                          <v-layout>                         
                            <v-flex xs6>
                            <v-icon color="green" v-if="applicationInfo.logo">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                            </v-flex>
                             <v-flex xs6>
                            <a v-if="applicationInfo.logo!==null" download="organisationLogo.jpg" :href="applicationInfo.logo"><v-icon medium color="primary" >cloud_download</v-icon></a>
                             </v-flex>
                          </v-layout>
                        </v-flex>
                        
                    </v-layout>
                   <v-layout v-if="applicationInfo.logo!==null" row wrap>
                   <v-flex xs12>
                      <v-img
                      :src="applicationInfo.logo"
                      max-height="100px"
                      contain
                    ></v-img>
                   </v-flex>
                   </v-layout>
                    
                    <v-layout justify-center>
                      <v-flex xs2>
                        <v-layout>                         
                         <v-flex xs6>
                       <v-icon @click="$refs.fileRegInput.click()" medium color="primary">cloud_upload</v-icon>
                        <input style="display: none" class="file-input" @change="selectFile($event, 'companyRegistrationDocument')"  ref="fileRegInput" type="file">
                        </v-flex>
                        </v-layout>
                        </v-flex>
                        <v-flex xs10>
                            <h2 class="subheading grey--text font-weight-bold">Company Registration Document Complete: </h2>
                        </v-flex>
                        <v-flex xs2>
                          <v-layout>                         
                            <v-flex xs6>
                             <v-icon color="green" v-if="applicationInfo.companyRegistrationDocument">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                            </v-flex>
                             <v-flex xs6>
                           <a  v-if="applicationInfo.companyRegistrationDocument!==null" download="organisationRegistrationDocument.pdf" :href="applicationInfo.companyRegistrationDocument"><v-icon medium color="primary">cloud_download</v-icon></a>
                             </v-flex>
                          </v-layout>
                        </v-flex>
                        
                    </v-layout>
                      <v-layout justify-center>
                      <v-flex xs2>
                        <v-layout>                         
                         <v-flex xs6>
                           <v-icon @click="$refs.fileSlaInput.click()" medium color="primary">cloud_upload</v-icon>
                          <input style="display: none" class="file-input" @change="selectFile($event, 'slaDocument')"  ref="fileSlaInput" type="file">
                        </v-flex>
                        </v-layout>
                        </v-flex>
                        <v-flex xs10>
                          <h2 class="subheading grey--text font-weight-bold">SLA Document Complete: </h2>
                        </v-flex>
                        <v-flex xs2>
                          <v-layout>                         
                            <v-flex xs6>
                            <v-icon color="green" v-if="applicationInfo.slaDocument">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                            </v-flex>
                             <v-flex xs6>
                             <a  v-if="applicationInfo.slaDocument!==null" download="organisationSLADocument.pdf" :href="applicationInfo.slaDocument"><v-icon medium color="primary">cloud_download</v-icon></a>
                             </v-flex>
                          </v-layout>
                        </v-flex>
                        
                    </v-layout>

                    <v-layout justify-center>
                      <v-flex xs2>
                        <v-layout>                         
                         <v-flex xs6>
                         <v-icon @click="$refs.fileIcasaInput.click()" medium color="primary">cloud_upload</v-icon>
                          <input style="display: none" class="file-input" @change="selectFile($event, 'icasaDocument')"  ref="fileIcasaInput" type="file">
                         </v-flex>
                        </v-layout>
                        </v-flex>
                        <v-flex xs10>
                            <h2 class="subheading grey--text font-weight-bold">ICASA Document Complete: </h2>
                        </v-flex>
                        <v-flex xs2>
                          <v-layout>                         
                            <v-flex xs6>
                            <v-icon color="green" v-if="applicationInfo.icasaDocument">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                            </v-flex>
                             <v-flex xs6>
                       <a  v-if="applicationInfo.icasaDocument!==null" download="organisationICASADocument.pdf" :href="applicationInfo.icasaDocument"><v-icon medium color="primary">cloud_download</v-icon></a>
                             </v-flex>
                          </v-layout>
                        </v-flex>  
                                             
                    </v-layout>
                     <v-layout justify-center>
                       <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold">ICASA License Number: </h2>
                        </v-flex>
                        <v-flex xs6>
                       <v-text-field class="mt-0 pt-0 mx-2" v-model="applicationInfo.icasaLicenseNumber"></v-text-field>
                         </v-flex>
                    </v-layout> 
                    </v-flex>
              </v-layout>
            </v-container>
            </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
     </v-card>
     </div>

<v-dialog persistent v-model="chooseModules" max-width="750px"> 
<v-card>
  <v-toolbar flat color="primary">
        <h3 class='headline white--text'>Give Organisation Access To Modules</h3>
        </v-toolbar>
        <v-card-text>
      <v-data-table
        :headers="modulesHeaders"
        class="elevation-1"
        :items="allModules"
        :rows-per-page-items="[25, 50, 100, 250]"
        v-model="modules"
        item-key="id"
        align-center
        select-all
      >
        <template v-slot:items="props">
          <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td
            class="text-xs-center"
          >{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
           <v-btn v-if="modules.length>0" round color="primary" @click="chooseModules=false;saveModuleChanges(); choosePackages=true ">NEXT</v-btn>
           <v-btn v-else disabled round color="primary">NEXT</v-btn>
          </v-layout>
        </v-card-actions>

</v-card>
</v-dialog>

    <v-dialog persistent v-model="choosePackages" max-width="900px">
  
  <v-toolbar flat color="primary">
        <h3 class='headline white--text'>Add Organisation To Network</h3>
        </v-toolbar>

     <v-card flat>
    <v-container style="text-align:center">
      <v-layout wrap>
              <v-layout >
                  <v-flex xs6 >
                      <v-flex >
                      <v-checkbox class="subheading grey--text" label="Share all packages on all networks" v-model="allPackagesSelected" primary hide-details></v-checkbox>
                        </v-flex>                  
                    </v-flex>
                    <v-flex xs6 >
                    <v-layout >
                    <v-flex xs6>
                            <h2 style="text-align:center" class="mt-4 subheading grey--text">Preferred VLAN: </h2>
                    </v-flex>
                    <v-flex xs5>
                        <v-text-field   v-model="applicationInfo.preferredVlan"></v-text-field>
                    </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
      <v-flex xs12 v-if="!allPackagesSelected" >
         <div>
         <v-data-table
         v-model="allSelected"
         select-all
         :loading="loading"
        class="elevation-1"
        :items="packages"
        :expand="expand"
        item-key="locationNetworkId"
        :rows-per-page-items="[25, 50, 100, 250]"
        style="cursor: pointer"
        align-center
      >
        <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
          <td class="text-xs-left"><v-icon v-if="!props.expanded" class="justify-center">chevron_right</v-icon><v-icon v-else>keyboard_arrow_down</v-icon>{{props.item.locationNetwork.name}}</td>
        </tr>
        </template>
      
     <template v-slot:expand="props">
        <v-data-table
          v-model="allNetworksSelected[props.item.locationNetworkId]"
         :items="props.item.packagesFnoLocationNetworks"
          hide-actions
          select-all
         :headers="submoduleHeaders"
         :rows-per-page-items="[25, 50, 100, 250]"
        >
        <template v-slot:items="props">
          <td>
          <v-checkbox :key="key" @change="selectedItem(props.item)"  v-model="props.selected" primary hide-details></v-checkbox>
        </td> 
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packageCode}}</td>
        <td class="text-xs-center">
          {{props.item.packagesFno.speedProfile.downloadMbps}}/
          {{props.item.packagesFno.speedProfile.uploadMbps}} Mbps {{props.item.packagesFno.speedProfile.contentionRatio}}
        </td>
        <td class="text-xs-center">{{props.item.packagesFno.packageBasePrice | currency}}</td>
         
            </template>
        </v-data-table>
      </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
 </div>
        </v-flex> 
      </v-layout>
    </v-container>
 <v-card-actions>
          <v-layout justify-center>
          <v-btn v-if="selected.length>0" round color="primary" @click="choosePackages=false; addIspToNetwork()">Submit</v-btn>
          <v-btn v-else disabled round color="primary">Submit</v-btn>
          </v-layout>
        </v-card-actions>
        
     </v-card>
     </v-dialog>

  <v-dialog v-model="deniedReasonModal" max-width="750px">
    <v-card flat color="white">
       <v-toolbar flat color="primary">
        <h3 class='headline white--text'>Please provide a reason for denying the application</h3>

      </v-toolbar>
      <v-card-text>
        <v-textarea
        label="Reason for Rejection"
        v-model="deniedReason"
        >

        </v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn round color="primary" class="white--text" @click="deniedReasonModal=false">Cancel</v-btn>
          <v-btn v-if="deniedReason!==''&&typeof deniedReason!=='undefined'" round color="primary" class="white--text" @click="rejectApplication">Reject Application</v-btn>

        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
  <!-- Similar Contacts Modal -->
  <v-dialog v-model="similarContactsModalPrimary" max-width='750px'>
    <v-card>
      <v-toolbar flat color="primary">
        <h3 class='headline white--text'>SIMILAR CONTACTS</h3>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
      </v-toolbar>
      <v-card-text>
         <v-flex xs12 sm6 md6 lg6 v-for="person in linkedPrimaryContacts" :key="person.name">
                      <v-card hover class="text-xs-center mb-2 mx-2">
                        <div
                          class="subheading text-uppercase"
                        >{{person.name}} {{person.surname}}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">smartphone</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{person.mobileNumber}}</div>
                          </v-flex>
                          </v-layout>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">email</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{person.emailAddress}}</div>
                          </v-flex>
                          </v-layout>
                          <v-layout>
                              <v-flex xs2 class="text-xs-right">
                               <v-icon small color="grey">perm_identity</v-icon>
                          </v-flex>
                          <v-flex xs8 justify-left>
                               <div class="grey--text"> {{person.idNumber}}</div>
                          </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                          <v-btn color="light-blue white--text" round @click="mergePrimaryContact(person)">
                            <v-icon small>call_merge</v-icon>Merge
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>

      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn round color="primary" @click="similarContactsModalPrimary=false">Cancel</v-btn>

        </v-layout>
      </v-card-actions>
    </v-card>

  </v-dialog>


<!-- Edit Contact -->
<v-dialog persistent v-model="editContactModal" max-width="750px">
<v-card>
  <v-toolbar flat color="primary">
        <h3 class='headline white--text'>EDIT CONTACT</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="editedContact.name" label="Name"></v-text-field>
          <v-text-field v-model="editedContact.surname" label="Surname"></v-text-field>
          <v-text-field v-model="editedContact.idNumber" label="ID Number"></v-text-field>
          <v-text-field v-model="editedContact.emailAddress" label="Email Address"></v-text-field>
          <v-text-field v-model="editedContact.mobileNumber" label="Mobile Number"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
             <v-btn round color="primary" @click="editContactModal=false, editedContact={}">Cancel</v-btn>
          <v-btn round color="primary" @click="saveEditedContact ">Save</v-btn>
          </v-layout>
        </v-card-actions>

</v-card>
</v-dialog>


  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
data() {
    return {
      vlans:[],
         modulesHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ],
      newOrganisationId: null,
      adminUserRoleId: null,
       modules: [],
      allModules: [],
      choosePackages: false,
      chooseModules: false,
      tabs: [
        { name: "orgInfo", displayName: "Organisation Info" },
        { name: "contactInfo", displayName: "Contact Info" },
        { name: "linksTab", displayName: "Links & Documents" },
      ],
      activeTabName: "",
      selectall:true,
      length:0,
      count:0,
      temp:[],
      display:false,
      allSelected:[],
      allNetworksSelected:[],
      allPackagesSelected:true,
      key:0,
      selected:[],
      loading: false,
      packagesFnoLocationNetworks:[],
      packagesFno:[],
      fnoPackagesGenerated:false,
      chosenIspsArray: [],
      chosenFnoCats: [],
      packageFnoCatsArrays: [],
      packageIspLocationNetworks: [],
      speedProfiles: [],
      speedProfilesArray: [],
      locationNetworks:[],
      snackbar: false,
      text: '',
        editedContact: {},
        editContactModal: false,
        xeroContacts: [],
        similarXeroContacts: [],
        deniedReasonModal: false,
        applicationInfo:'',
        locationContacts:[],
        showApplicationContacts: true,
        showLocationContacts: false,
        linkedPrimaryContacts:[],
        deniedReason: '',
        similarContactsModalPrimary: false,
        xeroContactsModal: false,
        allVlans:[],
        organisationTypes:[],
        expand: true,
        y: "top",
          submoduleHeaders: [
        {
          text: "Package Category",
          align: "center",
          value: "packageFnoCat.packageCatType"
        },
        {
          text: "FNO Package Code",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Price",
          align: "center",
          value: "packageBasePrice"
        },
      ],
       regNameRules: [
        v => !!v || 'Registered Name is required'
      ],
       nameRules: [
        v => !!v || 'Trading-As Name is required'
      ],
      billingEmailRules: [
        v => !!v || 'Billing E-mail is required',
             v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Billing E-mail must be valid',
      ],
      salesEmailRules: [
        v => !!v || 'Sales E-mail is required',
             v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Sales E-mail must be valid',
      ],
      technicalEscalationsEmailRules:[
        v => !!v || 'Technical Escalations E-mail is required',
             v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Technical Escalations E-mail must be valid',
      ],
      technicalEscalationsContactNumberRules:[
        v => !!v || 'Technical Escalations Contact Number is required',
        v => v && v.length > 9 || 'Technical Escalations Contact Number should be 10 digits'
      ],
      emailRules: [
        v => !!v || 'Primary Contact E-mail is required',
             v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Primary Contact E-mail must be valid',
      ],
      webUrlRules:[
         v => !!v || 'Website URL is required',
         v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(v) || 'Website URL must be valid'
      ], 
      fupUrlRules:[
         v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(v) || 'FUP URL must be valid'
      ], 
      tcLinkRules:[
         v => !!v || "T's & C's link is required",
          v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(v) || "T's & C's link must be valid"
      ],
      line2Rules: [
        v => !!v || 'Street No. & Name is required'
      ],
        line3Rules: [
        v => !!v || 'City is required'
      ],
        line4Rules: [
        v => !!v || 'Zip Code is required'
      ],
       line5Rules: [
        v => !!v || 'Province is required'
      ],
      orgTypeRules:[
         v => !!v || "Organisation type is required",
      ],
       customerEmailRules: [
        v => !!v || 'Customer Support E-mail is required',
             v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Customer Support E-mail must be valid',
      ],
        customerContactRules: [
        v => !!v || 'Customer Support Contact Number is required',
        v => v && v.length > 9 || 'Customer Support Contact Number should be 10 digits'
      ],
        customerWhatsappRules: [
        v => !!v || 'Customer Support Whatsapp Number is required',
        v => v && v.length > 9 || 'Customer Support Whatsapp Number should be 10 digits'
      ],
        customerEmailDescriptionRules: [
        v => !!v || 'Customer Support Email Description is required'
      ],
      customerTelephoneDescriptionRules: [
        v => !!v || 'Customer Support Telephone Description is required'
      ],
        packages:[]
    }
},
watch:{
  
  allPackagesSelected(value){    
    if(value){
       let temp =[]
      for(let j=0; j<this.packagesFnoLocationNetworks.length; j++){
        let id = this.packagesFnoLocationNetworks[j][0].locationNetworkId
        temp[id]=this.packagesFnoLocationNetworks[j]
      }
      this.selected=[]
      this.selected=temp   
    }
    },
     allSelected(value){ 
      if(value.length>0){
       let temp =[]
      for(let j=0; j<this.packagesFnoLocationNetworks.length; j++){
        let id = this.packagesFnoLocationNetworks[j][0].locationNetworkId
        temp[id]=this.packagesFnoLocationNetworks[j]
      }
      this.allNetworksSelected= temp
      this.selected=[]
      this.selected=temp
      }else{
         this.allNetworksSelected= []
      }
    }
},
async created(){
    this.setActiveTabName('orgInfo')
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/organisationApplications/:organisationApplicationId'})
     if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (await this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }  
}, 
methods:{
  displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  async initialize(){
        await this.getApplication();
        this.getOrgTypes()
        this.fetchLocationNetworks()
        this.fetchAllPackagesFnoLocationNetworks()    
        this.fetchModules()
        this.generateVlans()
    },
    generateVlans(){
      for(let i=1; i<4097; i++){
        this.vlans.push(i)
      }
    },
  async saveModuleChanges() {
      for (let i = 0; i < this.modules.length; i++) {
          await Api().post("/organisationModule", {
            moduleId: this.modules[i].id,
            organisationId: this.newOrganisationId,
            isActive: true,
            isDeleted: false
          }).then(async response=>{
            for (let x=0;x<this.modules[i].moduleSubmodules.length;x++){
              if(this.modules[i].moduleSubmodules[x].isActive&&!this.modules[i].moduleSubmodules[x].isDeleted&&
              this.modules[i].moduleSubmodules[x].submodule.isActive&&!this.modules[i].moduleSubmodules[x].submodule.isDeleted){
                // Organisation User Roles - add permissions
               Api()
                  .post('/routePermission',{
                    moduleSubmoduleId: this.modules[i].moduleSubmodules[x].id,
                    userRoleId: this.adminUserRoleId,
                    create: true,
                    read: true,
                    update: true,
                    delete: true,
                    organisationId: this.newOrganisationId,
                    isActive: true,
                    isDeleted: false
                  })  
              }
            }
          });
       
      }
   
    },
  fetchModules() {
      Api()
        .get("/modules")
        .then(response => {
          this.allModules = response.data;
        });
    },
   async fetchAllPackagesFnoLocationNetworks() {
      Api()
        .get("/packagesFnoLocationNetwork")
        .then(response => { 
          this.selected = response.data;
           
             });
    },
 async fetchPackagesFnoLocationNetworks() {   
      for(let i=0; i<this.locationNetworks.length; i++){
      await Api()
        .get(
          "/packagesFnoLocationNetwork/showByLocationNetwork/" +
            this.locationNetworks[i].id
        )
        .then(response => {
          if(response.data.length>0){
              this.packagesFnoLocationNetworks.push(response.data);    
              
             this.packages.push({
                locationNetworkId: this.locationNetworks[i].id,
                locationNetwork: this.locationNetworks[i],
                packagesFnoLocationNetworks: response.data
                })
              
          }  
        });
      } 
         this.allSelected=this.packages
         this.loading=false
         this.display =true
    },
  fetchLocationNetworks() {
     this.loading=true
      Api()
        .get("/locationNetworks/active")
        .then(response => {
           this.locationNetworks = response.data;
           this.fetchPackagesFnoLocationNetworks()
        });       
    },
  async fetchPackagesIspLocationNetworks() {
    for(let i=0; i<this.locationNetworks.length; i++){
      await Api()
        .get("/supplier/packagesIsps/byNetwork/" + this.locationNetworks[i].id)
         .then(response => {
          this.packageIspLocationNetworks = response.data;
        });
    }      
    },
     validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validLink(link) {
      var re = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
      return re.test(link);    
    },
    async selectFile(event, type) {
     this.file = event.srcElement.files[0];
    await this.uploadFile(this.file, type)
   
    },
    async uploadFile(file, type){
     var reader = await new FileReader();
     await reader.readAsDataURL(file);
     reader.onload = () => {     
     this.setResult(reader.result, type)
      }
     reader.onerror = function() {
        console.log('there are some problems');
    };
    },
    setResult(result, type){
      if(type=='slaDocument'){
      this.applicationInfo.slaDocument=result
      this.key+=1
       Api()
          .put('/organisationApplications/'+this.applicationInfo.id,{
            slaDocument: this.applicationInfo.slaDocument
          })      
      }else if(type=='icasaDocument'){
      this.applicationInfo.icasaDocument=result
      this.key+=1
       Api()
          .put('/organisationApplications/'+this.applicationInfo.id,{
            icasaDocument: this.applicationInfo.icasaDocument
          })    
      } 
      else if(type=='companyRegistrationDocument'){
      this.applicationInfo.companyRegistrationDocument=result
      this.key+=1
       Api()
          .put('/organisationApplications/'+this.applicationInfo.id,{
            companyRegistrationDocument: this.applicationInfo.companyRegistrationDocument
          })    
      }
       else if(type=='logo'){
      this.applicationInfo.logo=result
      this.key+=1
       Api()
          .put('/organisationApplications/'+this.applicationInfo.id,{
            logo: this.applicationInfo.logo
          })    
      }        
    }, 
    selectedItem(selected){
        this.selected=this.allNetworksSelected
    },
    async addIspToNetwork(){        
       this.temp=[]
        for(let k=0; k<this.selected.length;k++){
          if(typeof(this.selected[k])!=='undefined'){
            for(let j=0; j<this.selected[k].length; j++){
                 this.temp.push(this.selected[k][j])
            }             
          }
        }
      let post =[]
      for (let i=0; i< this.temp.length;i++){
        post.push({
        customerOrganisationId: this.newOrganisationId,
        locationNetworkId: this.temp[i].locationNetworkId,
        packagesFnoId: this.temp[i].id,
        isActive: true,
        isDeleted: false
        })}
        Api()
      .post('/ispLocationNetwork',{
        batch: post
       }) 
        Api()
      .put('/organisationApplications/'+this.applicationInfo.id,{
            preferredVlan: this.applicationInfo.preferredVlan
          })        
          this.text = 'Successfully Resolved!'
          this.snackbar = true
    },
      getOrgTypes() {
      Api()
        .get("/organisationType")
        .then(response => {
          this.organisationTypes = response.data;
        });
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    filterByValue(array, string) { return array.filter(o => { return Object.keys(o).some(k => { 
      if(typeof o[k] === 'string') return o[k].toLowerCase().includes(string.toLowerCase()); }); }); },
    async fetchXeroContacts(){
      await Api()
      .get('/xero/allContacts')
      .then(response=>{
        this.xeroContacts=response.data
      })
    },
    async findSimilarContacts(contact, name, email){
      let similarContacts=[]
      let similarNames= await this.filterByValue(this.xeroContacts, name)
      for(let a =0; a< similarNames.length;a++){
        let match = await Math.round(this.similarity(name,similarNames[a].Name)*10000)/100
        await similarContacts.push({xeroContactId: similarNames[a].ContactID, match: match, name: similarNames[a].Name, email: similarNames[a].EmailAddress})
      }
      this.similarXeroContacts=similarContacts
      if(this.similarXeroContacts.length>0){
        this.xeroContactsModal=true
      } else {
        this.xeroContactsModal=false
        confirm('Are you sure you would like to generate the invoice for '+contact.name+ ' '+contact.surname+'?')&&
          this.generateXeroInvoice(contact)
      }
    },
    similarity(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
},
    editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = new Array();
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0)
        costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue),
              costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0)
      costs[s2.length] = lastValue;
  }
  return costs[s2.length];
},    
    verifyDocument(){
      if(this.authUpdate(this.$store.state.currentRoute)){
        Api()
        .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
            isDocumentsVerified: true,
            documentsVerifiedById: this.$store.state.user.id,
            documentsVerifiedDate: new Date(),
        }).then(response=>{
            this.applicationInfo.isDocumentsVerified=true
        })
      }
    },
    verifyLinks(){
    if(this.authUpdate(this.$store.state.currentRoute)){
        Api()
        .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
            isLinksVerified: true,
            linksVerifiedById: this.$store.state.user.id,
            linksVerifiedDate: new Date(),
            fupUrl: this.applicationInfo.fupUrl,
            websiteUrl: this.applicationInfo.websiteUrl,
            termsAndConditionsLink: this.applicationInfo.termsAndConditionsLink
        }).then(response=>{
            this.applicationInfo.isLinksVerified=true
        })
      }
    },
    validateLink(){      
         var expression = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
         var regex = new RegExp(expression);
         if(((this.applicationInfo.websiteUrl).match(regex)!==null)&&((this.applicationInfo.termsAndConditionsLink).match(regex)!==null))
        {
          return true
        }
    },
    validateFields(){
    if(this.authUpdate(this.$store.state.currentRoute)){
        Api()
        .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
                isValidated: true,
                validatedById: this.$store.state.user.id,
                validatedDate: new Date(),
                registeredName: this.applicationInfo.registeredName,
                name: this.applicationInfo.name,
                vatNo: this.applicationInfo.vatNo,
                physicalAddressLine1: this.applicationInfo.physicalAddressLine1,
                physicalAddressLine2: this.applicationInfo.physicalAddressLine2,
                physicalAddressLine3: this.applicationInfo.physicalAddressLine3,
                physicalAddressLine4: this.applicationInfo.physicalAddressLine4,
                physicalAddressLine5: this.applicationInfo.physicalAddressLine5,
                organisationTypeId: this.applicationInfo.organisationTypeId
        }).then(response=>{
            this.applicationInfo.isValidated=true
        })
      }
    },
   
    editContact(contactType){
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.editedContact.contactType="Primary"
        this.editedContact.name = this.applicationInfo.primaryContactFirstname
        this.editedContact.surname = this.applicationInfo.primaryContactLastname
        this.editedContact.idNumber = this.applicationInfo.primaryContactIdNumber
        this.editedContact.emailAddress = this.applicationInfo.primaryContactEmailAddress
        this.editedContact.mobileNumber = this.applicationInfo.primaryContactMobileNumber     
        this.editContactModal=true
      }
    },
    saveEditedContact(){
      if(this.authUpdate(this.$store.state.currentRoute)){
        Api()
        .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
          primaryContactFirstname: this.editedContact.name,
          primaryContactLastname: this.editedContact.surname,
          primaryContactMobileNumber: this.editedContact.mobileNumber,
          primaryContactEmailAddress: this.editedContact.emailAddress,
          primaryContactIdNumber: this.editedContact.idNumber
        }).then(response=>{
          this.initialize()
          this.editContactModal=false
          this.editedContact={}
        })     
    }},
    addContact(contactType){
      if(this.authUpdate(this.$store.state.currentRoute)){
      let name = null
      let surname = null
      let idNumber = null
      let mobileNumber = null
      let emailAddress = null
      let password ='P@ssw0rd1234'
      let permissions = 'End Client'
      let isActive = true
       Api()
          .get('/organisationApplications/'+this.$route.params.organisationApplicationId)
          .then(response=>{
         Api()
      .post('/contacts',{
          name: this.applicationInfo.primaryContactFirstname,
          surname: this.applicationInfo.primaryContactLastname,
          idNumber: this.applicationInfo.primaryContactIdNumber,
          mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          emailAddress: this.applicationInfo.primaryContactEmailAddress,
          password: password,
          permissions: permissions,
          isActive: isActive,
          organisationId: response.data.primaryOrganisationId
      }).then(response=>{
          Api()
          .put('/organisationApplications/'+this.applicationInfo.id,{
            primaryContactId: response.data.id
          }).then(this.applicationInfo.primaryContactId=response.data.id)        
      })
          })     
      }
    },    
    getLinkedContacts(){
      Api()
      .get('/contacts/linked',{
        params: {
          idNumber: this.applicationInfo.primaryContactIdNumber,
          emailAddress: this.applicationInfo.primaryContactEmailAddress,
          mobileNumber: this.applicationInfo.primaryContactMobileNumber
        }
      }).then(response=>{
        this.linkedPrimaryContacts=response.data
      })
    },
    mergePrimaryContact(item){
      if(this.authUpdate(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to update the existing contact?")&&
      Api()
      .put('/contacts/'+item.id,{
          name: this.applicationInfo.primaryContactFirstname,
          surname: this.applicationInfo.primaryContactLastname,
          idNumber: this.applicationInfo.primaryContactIdNumber,
          mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          emailAddress: this.applicationInfo.primaryContactEmailAddress
      }).then(response=>{
        Api()
        .put('/organisationApplications/'+this.applicationInfo.id,{
          primaryContactId: item.id
        }).then(this.applicationInfo.primaryContactId=item.id)
      })
      this.similarContactsModalPrimary=false
      }
    },
    verifyContact(){
      if(this.authUpdate(this.$store.state.currentRoute)){
        Api()
        .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
            isContactVerified: true,
            contactVerifiedById: this.$store.state.user.id,
            contactVerifiedDate: new Date(),
            primaryContactFirstname: this.applicationInfo.primaryContactFirstname,
            primaryContactLastname: this.applicationInfo.primaryContactLastname,
            primaryContactMobileNumber: this.applicationInfo.primaryContactMobileNumber,
            primaryContactEmailAddress: this.applicationInfo.primaryContactEmailAddress,
            primaryContactIdNumber: this.applicationInfo.primaryContactIdNumber,
            primaryContactTitle: this.applicationInfo.primaryContactTitle,
          
            customerSupportEmail: this.applicationInfo.customerSupportEmail,
            customerSupportTelephone: this.applicationInfo.customerSupportTelephone,
            customerSupportEmailDescription: this.applicationInfo.customerSupportEmailDescription,
            customerSupportTelephoneDescription: this.applicationInfo.customerSupportTelephoneDescription,
            customerSupportWhatsappDescription: this.applicationInfo.customerSupportWhatsappDescription,
            customerSupportWhatsapp: this.applicationInfo.customerSupportWhatsapp,
        }).then(response=>{
            this.applicationInfo.isContactVerified=true
        })
      }
    },
    async approve(){
    Api()
    .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
      //preferredVlan: this.applicationInfo.preferredVlan,
      isApproved: true,
      approvedById: this.$store.state.user.id,
      isResolved: true,
      resolvedById: this.$store.state.user.id,
      resolvedDate: new Date()
    }).then(response=>{
      this.applicationInfo.isApproved=true,
      this.applicationInfo.isResolved=true    
      Api() .post('/organisation',{
                name: this.applicationInfo.name,
                registeredName: this.applicationInfo.registeredName,
                organisationTypeId: this.applicationInfo.organisationTypeId,
                primaryColour: this.applicationInfo.primaryColour,
                secondaryColour: this.applicationInfo.secondaryColour,
                slaDocument: this.applicationInfo.slaDocument,
                icasaDocument: this.applicationInfo.icasaDocument,
                companyRegistrationDocument: this.applicationInfo.companyRegistrationDocument,
                logo: this.applicationInfo.logo,
                vatNo: this.applicationInfo.vatNo,
                fupUrl: this.applicationInfo.fupUrl,
                websiteUrl: this.applicationInfo.websiteUrl,
                termsAndConditionsLink: this.applicationInfo.termsAndConditionsLink,            
                primaryOrganisationId: this.$store.state.currentOrg.org.id,
                physicalAddressLine1: this.applicationInfo.physicalAddressLine1,
                physicalAddressLine2: this.applicationInfo.physicalAddressLine2,
                physicalAddressLine3: this.applicationInfo.physicalAddressLine3,
                physicalAddressLine4: this.applicationInfo.physicalAddressLine4,
                physicalAddressLine5: this.applicationInfo.physicalAddressLine5,
                customerSupportEmail: this.applicationInfo.customerSupportEmail,
                customerSupportTelephone: this.applicationInfo.customerSupportTelephone,
                customerSupportEmailDescription: this.applicationInfo.customerSupportEmailDescription,
                customerSupportTelephoneDescription: this.applicationInfo.customerSupportTelephoneDescription,
                customerSupportWhatsappDescription: this.applicationInfo.customerSupportWhatsappDescription,
                customerSupportWhatsapp: this.applicationInfo.customerSupportWhatsapp,
                icasaLicenseNumber: this.applicationInfo.icasaLicenseNumber,
                preferredVlan: this.applicationInfo.preferredVlan,
                isActive: true,
                isDelete: false
            }).then(response=>{     
              this.newOrganisationId= response.data.id         
              this.generateOrganisationToken(response.data)             
              
              Api()
              .post('/userRole',{
                name: 'Admin',
                description: 'Default Admin Role',
                userGroupId: 4,
                isAdmin: true,
                organisationId: response.data.id,
                isActive: true,
                isDelete: false
              }).then(response=>{
                this.adminUserRoleId=response.data.id
                this.chooseModules=true
                Api()
              .post('/userRoleContact/subOrganisation',{
                contactId: this.applicationInfo.primaryContactId,
                userRoleId: response.data.id,
                organisationId: response.data.organisationId,
                isActive: true,
                isDeleted: false
              })
              })
      })
    }   
    )
    },
     generateOrganisationToken(item){
      Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name
      })
      .then(response=>{
        let token=response.data.token
        Api()
        .put('/organisation/'+item.id,{
          token: token
        })
      })
    },
    rejectApplication(){
      if(this.authUpdate(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to reject this application?")&&
      Api()
      .put('/organisationApplications/'+this.$route.params.organisationApplicationId,{
        isResolved: true,
        resolvedById: this.$store.state.user.id,
        resolvedDate: new Date(),
        isDenied: true,
        deniedReason: this.deniedReason,
        deniedById: this.$store.state.user.id
      }).then(this.applicationInfo.isResolved=true, this.applicationInfo.isDenied=true,this.deniedReasonModal=false)
      }
    },
    async getApplication(){
        await Api()
        .get('/organisationApplications/'+this.$route.params.organisationApplicationId)
        .then(response=>{
            this.applicationInfo=response.data
        })
    },
}
}
</script>

<style>

</style>
